import { withStyles, WithStyles } from "@mui/styles";
import messageBlockStyle from "assets/jss/mui-extras/messageBlockStyle";
import classNames from "classnames";
import { MuiColors } from "components/MuiExtras/Typography/MuiColor";
import * as React from "react";

interface IProps {
    color: MuiColors;
    flat?: boolean;
};

type Props = IProps & React.DetailedHTMLProps<React.HTMLAttributes<HTMLSpanElement>, HTMLSpanElement> & WithStyles<typeof messageBlockStyle>;

const MuiReverse: React.FC<Props> = (props) => {
    const { classes, className, color, flat, children, ...rest } = props;

    const cls = classNames(
        {
            [className]: className,
            [classes[color]]: color,
            [classes.flat]: flat === true,
            [classes.message]: flat !== true,
        }
    );

    return <span className={cls} {...rest}>{children}</span>;
};

MuiReverse.defaultProps = {
    color: "primary",
};

export default withStyles(messageBlockStyle)(MuiReverse);
